import React, { useEffect, useMemo, useState } from 'react';
import { Image } from 'antd';

const FALLBACK_IMAGE = '/assets/img/byos-no-image.png';

function normalizeImages(galleryList) {
  if (Array.isArray(galleryList)) {
    return galleryList.filter(Boolean);
  }

  if (typeof galleryList === 'string') {
    return galleryList
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
}

function ProductGallery({ galleryList }) {
  const images = useMemo(() => normalizeImages(galleryList), [galleryList]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [images]);

  if (!images.length) {
    return (
      <div className="product-gallery product-gallery--empty">
        <img
          className="product-gallery__empty-image"
          src={FALLBACK_IMAGE}
          alt="Product preview unavailable"
        />
      </div>
    );
  }

  const activeImage = images[Math.min(activeIndex, images.length - 1)] || FALLBACK_IMAGE;

  return (
    <div className="product-gallery">
      <div className="product-gallery__hero">
        <Image
          src={activeImage}
          alt="Product preview"
          className="product-gallery__hero-image"
          preview={{
            mask: false,
          }}
          onError={(event) => {
            event.target.src = FALLBACK_IMAGE;
          }}
        />
      </div>

      {images.length > 1 ? (
        <div className="product-gallery__thumbs" aria-label="Product image thumbnails">
          {images.map((image, index) => {
            const isActive = index === activeIndex;

            return (
              <button
                key={`${image}-${index}`}
                type="button"
                className={`product-gallery__thumb ${isActive ? 'product-gallery__thumb--active' : ''}`}
                onClick={() => setActiveIndex(index)}
                aria-label={`View product image ${index + 1}`}
                aria-pressed={isActive}
              >
                <img
                  src={image}
                  alt={`Product thumbnail ${index + 1}`}
                  className="product-gallery__thumb-image"
                  loading="lazy"
                  onError={(event) => {
                    event.target.src = FALLBACK_IMAGE;
                  }}
                />
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

export default ProductGallery;
